import { render, staticRenderFns } from "./mainPageList.vue?vue&type=template&id=a2441224"
import script from "./mainPageList.vue?vue&type=script&lang=js"
export * from "./mainPageList.vue?vue&type=script&lang=js"
import style0 from "./mainPageList.vue?vue&type=style&index=0&id=a2441224&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports